import { render, staticRenderFns } from "./VehicleActionsPage.vue?vue&type=template&id=47c23572&scoped=true&"
import script from "./VehicleActionsPage.vue?vue&type=script&lang=js&"
export * from "./VehicleActionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c23572",
  null
  
)

export default component.exports